  function isMobile() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  
  // Check for common mobile devices
    return (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase()));
  }

  const urlParams = new URLSearchParams(window.location.search);
   const currentType = urlParams.get('grid_list');
   const productClass = document.querySelectorAll('.productgrid--items');
   const defaultType = productClass.length >0 ?productClass[0].getAttribute("data-display"):"list-view";
   

  let collectionContainers = document.querySelectorAll('.collection__item');
  let collectionInfoBlockContainer = document.querySelectorAll('.collection__info__block');
  let collectionDescriptionBlock = document.querySelectorAll('.collection__description__block');
  let productContainers = document.querySelectorAll('.productitem__container');
  let collectionMaxHeight = 0;
  let collectionInfoBlockMaxHeight = 0;
  let collectionDescriptionBlockMaxHeight = 0
  let productMaxHeight = 0;


   resizeBlock();

    window.addEventListener("resize", (e)=>{
          collectionContainers.forEach((info) =>{ 
        info.style.height = `fit-content`;
      })
    
      collectionInfoBlockContainer.forEach((info) =>{
           info.style.height = `fit-content`;
        })
    
          collectionDescriptionBlock.forEach((info) =>{
           info.style.height = `fit-content`;
        })
    
         setInterval(
            resizeBlock(),2000
           )
       });
  
  function resizeBlock(){
    for (let i = 0; i < collectionContainers.length; i++) {
        if (collectionContainers[i].offsetHeight > collectionMaxHeight) {
            collectionMaxHeight = collectionContainers[i].offsetHeight;
        }
    }

       for (let i = 0; i < productContainers.length; i++) {
          if (productContainers[i].offsetHeight > productMaxHeight) {
          }
      }
    
     for (let i = 0; i < collectionInfoBlockContainer.length; i++) {
         if(collectionInfoBlockContainer[i].offsetHeight > collectionInfoBlockMaxHeight){
          collectionInfoBlockMaxHeight = collectionInfoBlockContainer[i].offsetHeight;
        }
     }
  
    for (let i = 0; i < collectionDescriptionBlock.length; i++) {
       if(collectionDescriptionBlock[i].offsetHeight > collectionDescriptionBlockMaxHeight){
        collectionDescriptionBlockMaxHeight = collectionDescriptionBlock[i].offsetHeight;
      }
    }
  
    collectionContainers.forEach((info) =>{ 
      info.style.height = `${collectionMaxHeight+20}px`;
    })

      
    if(currentType == null && defaultType =="grid-view"){
           document.querySelectorAll('.product--action').forEach((action) =>{
           action.style.position = 'absolute';
           action.style.bottom = '0px';
           action.style.width = 'inherit';
         })
      }

     collectionInfoBlockContainer.forEach((info) =>{
         info.style.height = `${collectionInfoBlockMaxHeight}px`;
      })

      collectionDescriptionBlock.forEach((info) =>{
         info.style.height = `${collectionDescriptionBlockMaxHeight}px`;
      })

    collectionMaxHeight=0;
  }